import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M10.512 1.447a5.75 5.75 0 0 1 6.468 2.678.75.75 0 0 1-1.3.75 4.252 4.252 0 0 0-7.052-.462A4.25 4.25 0 0 0 7.75 7v2.25H19A2.75 2.75 0 0 1 21.75 12v8A2.75 2.75 0 0 1 19 22.75H5A2.75 2.75 0 0 1 2.25 20v-8A2.75 2.75 0 0 1 5 9.25h1.25V7a5.75 5.75 0 0 1 4.262-5.553M12 14.25a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5"
      clipRule="evenodd"
    />
  </>
);

const LockOpenFilled = Icon('lock-open-filled', svgContents);

export default LockOpenFilled;
